import { z } from 'zod';
import { DocId, IsoTimestamp } from '../common.js';
/**
 * Persoonlijke demo-toegangscode (besluit 8 okt 2026): vervangt het gedeelde
 * demo-wachtwoord. Aangemaakt in Beheer > Demo-toegang van de ECHTE Kennishub,
 * gecontroleerd door de demo-service bij elke login en elk verzoek.
 *
 * Firestore-pad: `demo_access_codes/{id}` in de named database `demo` (root,
 * niet tenant-scoped; gedocumenteerde uitzondering in CLAUDE.md Hard Rule 1).
 *
 * De code zelf staat NERGENS leesbaar: alleen `codeHash` (sha256-hex van de
 * genormaliseerde code). De beheerder ziet hem eenmalig in het aanmaakantwoord.
 */
export const DemoAccessCodeRecord = z.object({
    id: DocId,
    codeHash: z.string().regex(/^[a-f0-9]{64}$/),
    naam: z.string().min(1).max(120),
    organisatie: z.string().min(1).max(160),
    createdAt: IsoTimestamp,
    createdByEmail: z.string().max(320),
    geldigTot: IsoTimestamp,
    laatstGebruiktOp: IsoTimestamp.optional(),
    voorwaardenAkkoordOp: IsoTimestamp.optional(),
    ingetrokkenOp: IsoTimestamp.optional(),
    ingetrokkenDoorEmail: z.string().max(320).optional(),
});
export const DemoAccessStatus = z.enum(['actief', 'verlopen', 'ingetrokken']);
/** Wat het beheerscherm te zien krijgt: alles behalve de hash. */
export const DemoAccessCodeView = DemoAccessCodeRecord.omit({ codeHash: true }).extend({
    status: DemoAccessStatus,
});
export const DEMO_ACCESS_GELDIG_DAGEN_STANDAARD = 14;
export const DEMO_ACCESS_GELDIG_DAGEN_MAX = 90;
export const CreateDemoAccessCodeInput = z.object({
    naam: z.string().trim().min(1).max(120),
    organisatie: z.string().trim().min(1).max(160),
    geldigDagen: z
        .number()
        .int()
        .min(1)
        .max(DEMO_ACCESS_GELDIG_DAGEN_MAX)
        .default(DEMO_ACCESS_GELDIG_DAGEN_STANDAARD),
});
/**
 * Body van POST /api/v1/auth/demo/login. Het veld accepteert een
 * toegangscode of (overgang) het oude gedeelde wachtwoord.
 */
export const DemoLoginBody = z.object({
    code: z.string().min(1).max(200),
    akkoordVoorwaarden: z.boolean().optional(),
});
/** Letterlijke tekst, besluit 8 okt 2026. Wijzigen = nieuw akkoord overwegen. */
export const DEMO_VOORWAARDEN_TITEL = 'Voorwaarden voor het gebruik van de SUPPOHRT Kennishub-demo';
export const DEMO_VOORWAARDEN = [
    'Deze demo is uitsluitend bedoeld om de Kennishub te bekijken en te beoordelen. Je krijgt de toegang persoonlijk; deel je code niet met anderen.',
    'De demo werkt niet live. Mila en Sara geven vooraf vastgelegde antwoorden, en alle gegevens zijn fictief. Aan de inhoud kun je geen rechten of adviezen ontlenen.',
    'Het is niet toegestaan de demo, het ontwerp, de teksten of de werking te kopiëren, na te bouwen, op te nemen of met derden te delen, geheel of gedeeltelijk.',
    'SUPPOHRT legt vast wanneer je code wordt gebruikt en kan je toegang op elk moment intrekken.',
    'Alle rechten op de Kennishub en de demo liggen bij SUPPOHRT.',
];
//# sourceMappingURL=demo-access.js.map